import { all } from 'redux-saga/effects';
import { compositeActionTypes } from 'actions/actionTypes';
import { createCompositeSaga } from './compositeSaga';

export default function* rootSaga() {
  yield all([
    ...Object.values(compositeActionTypes).map(createCompositeSaga()),
  ]);
}
